import { TopRightContainerComponent } from '../TopRightContainerComponent';
import { IconButton, useDisclosure } from '@chakra-ui/react';
import { TrackerPopover } from './TrackerPopover';
import { useActiveContext } from '@texas/hooks/useActiveContext';
import { TrackerContext } from './useTracker';
import { useMemo } from 'react';
import { defaultIconSize, Icons } from '../Icons';
import { EntityType } from '@texas/api/endpoints/trackerApi';
import { useTranslation } from 'react-i18next';

interface Props {
  entityId: number;
  entityType: EntityType;
  children: React.ReactNode;
}

export function TrackerWrapper({ entityId, entityType, children }: Props) {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { hasWatcher } = useActiveContext(TrackerContext);

  const tracked = useMemo(() => {
    return hasWatcher(entityId, entityType);
  }, [entityType, entityId, hasWatcher]);

  return (
    <TopRightContainerComponent
      role="group"
      bar={
        <TrackerPopover
          entityId={entityId}
          entityType={entityType}
          isOpen={isOpen}
          onClose={onClose}
        >
          <IconButton
            size="sm"
            variant="ghost"
            icon={<Icons.BullseyeArrow boxSize={defaultIconSize} />}
            aria-label={t('tracking.tracked')}
            onClick={(e) => {
              e.stopPropagation();
              onOpen();
            }}
            {...(!tracked ? { opacity: 0, _groupHover: { opacity: 1 } } : null)}
          />
        </TrackerPopover>
      }
    >
      {children}
    </TopRightContainerComponent>
  );
}
